import styled, { css } from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ImageContainer = styled.div<{
  $isLoaded?: boolean;
}>`
  width: 100%;
  height: 0;
  padding-top: 61%; // as in Figma  // check if we need fixed aspect ratio
  overflow: hidden;
  position: relative;
`;
